<div class="painel-header">
  <div class="header-content">
    <div class="header-text">
      <h2>Painel de Avaliação de Candidatos</h2>
      <p class="mat-body-1">Bem-vindo, Examinador. Siga as etapas abaixo para concluir a avaliação.</p>
    </div>
    <button mat-flat-button color="primary" class="btn-instrucoes" (click)="toggleInstrucoes()">
      <mat-icon>{{ instrucoesExpandidas ? 'close' : 'help_outline' }}</mat-icon>
      {{ instrucoesExpandidas ? 'Fechar' : 'Instruções' }}
    </button>
  </div>
</div>

<mat-card *ngIf="instrucoesExpandidas" class="card-instrucoes" [@slideDown]>
  <mat-card-content class="instrucoes-content">
    <div class="secao-instrucoes">
      <h3><mat-icon>person</mat-icon>Como Examinador</h3>
      <ul>
        <li><strong>Atribuir Notas:</strong> Acesse cada prova em andamento e atribua notas aos candidatos conforme os critérios estabelecidos.</li>
        <li><strong>Depositar Envelope:</strong> Após atribuir todas as notas de uma prova, deposite o envelope para finalizar sua avaliação.</li>
        <li><strong>Visualizar Classificação:</strong> Após depositar o envelope da última prova da fase, você poderá visualizar sua classificação individual.</li>
        <li><strong>Desempate:</strong> Caso existam empates, você será notificado para realizar o desempate dos candidatos.</li>
      </ul>
    </div>
    <div class="secao-instrucoes" *ngIf="isPresidente()">
      <h3><mat-icon>gavel</mat-icon>Como Presidente</h3>
      <ul>
        <li><strong>Consolidação de Fase:</strong> Ao final de cada fase, utilize o botão "Consolidação da Fase" para consolidar os resultados de todos os examinadores.</li>
        <li><strong>Classificação Geral:</strong> Após a consolidação, a classificação geral da fase estará disponível para todos os examinadores.</li>
        <li><strong>Progressão de Fase:</strong> A consolidação da Fase 1 é necessária para liberar o acesso às provas da Fase 2.</li>
      </ul>
    </div>
  </mat-card-content>
</mat-card>

<div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="24px" class="fases-container">

  <mat-card fxFlex="50" class="stage-card">
    <mat-card-header class="stage-header" [ngClass]="{'stage-completed': allFase1Concluida, 'header-cinza': allFase1Concluida}">
      <mat-card-title class="stage-title">FASE 1</mat-card-title>
      <div class="status-chip" [ngClass]="{'status-concluida': allFase1Concluida}">
        <mat-icon>{{ allFase1Concluida ? 'check_circle' : 'hourglass_empty' }}</mat-icon>
        <span>{{ allFase1Concluida ? 'Concluída' : 'Em Andamento' }}</span>
      </div>
    </mat-card-header>
    <mat-card-content>
      <div class="exams-grid">
        <div *ngFor="let prova of provasFase1" class="exam-card" [ngClass]="{'exam-completed': prova.concluido}">
          <div class="exam-info">
            <div class="exam-title-container">
              <span class="exam-title">{{ getNomeProva(prova.tipoProva) }}</span>
              <mat-icon *ngIf="!prova.concluido && prova.emAndamento" class="progress-icon">hourglass_empty</mat-icon>
            </div>
            <span class="exam-meta">Peso: {{ prova.provaPeso }}</span>
            <div *ngIf="isProvaProntaParaLancamento(prova)" class="scores-summary">
              <span>{{ prova.resumoNotas }}</span>
              <div *ngIf="todasNotasAtribuidas(prova) && !prova.comissaoNotaEnvelopeId" class="envelope-alert">
                <mat-icon color="warn">warning</mat-icon>
                <span>Envelope não depositado</span>
              </div>
              <div *ngIf="prova.comissaoNotaEnvelopeId" class="envelope-success">
                <mat-icon>check_circle</mat-icon>
                <span>Envelope depositado</span>
              </div>
            </div>
            <div *ngIf="prova.concluido" class="indicador-concluida">
              <mat-icon>check_circle</mat-icon>
              <span>Prova Concluída</span>
            </div>
          </div>
          <div class="exam-action">
            <button
              *ngIf="isProvaProntaParaLancamento(prova) && !prova.comissaoNotaEnvelopeId"
              mat-flat-button color="primary"
              [routerLink]="['/comissao-julgadora/listar-notas', idConcurso, prova.tipoProva]"
              [queryParams]="{ peso: prova.provaPeso }"
            >
              <mat-icon>edit_note</mat-icon>
              Atribuir Notas
            </button>

            <button
              *ngIf="isProvaProntaParaLancamento(prova) && prova.comissaoNotaEnvelopeId"
              mat-stroked-button color="primary"
              [routerLink]="['/comissao-julgadora/listar-notas', idConcurso, prova.tipoProva]"
              [queryParams]="{ peso: prova.provaPeso }"
            >
              <mat-icon>visibility</mat-icon>
              Visualizar Notas
            </button>

            <div *ngIf="!prova.concluido && !isProvaProntaParaLancamento(prova)"
                 class="acao-bloqueada" [matTooltip]="getBloqueioTooltip(prova)">
              <mat-icon>info_outline</mat-icon>
              <span>{{ getBloqueioReason(prova) }}</span>
            </div>

            <button
              *ngIf="isPresidente() && prova.emAndamento && !prova.concluido"
              mat-stroked-button
              (click)="consultarPendenciasProva(prova)"
              matTooltip="Consultar status de avaliação dos examinadores"
            >
              <mat-icon>info</mat-icon>
              Pendências
            </button>

          </div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions class="btn-actions-center">
      <div class="actions-row">
        <div class="action-column">
          <div [matTooltip]="getTooltipVisualizarClassificacao('FASE1')"
               matTooltipPosition="above"
               [matTooltipDisabled]="!getTooltipVisualizarClassificacao('FASE1')">
            <button mat-flat-button 
                    [color]="existeEmpateFase('FASE1') ? 'warn' : 'primary'"
                    [disabled]="!!getTooltipVisualizarClassificacao('FASE1')"
                    [class.pulse-animation]="existeEmpateFase('FASE1') && !getTooltipVisualizarClassificacao('FASE1')"
                    (click)="realizarDesempateFase('FASE1')">
              <mat-icon>{{ existeEmpateFase('FASE1') ? 'gavel' : 'visibility' }}</mat-icon>
              {{ existeEmpateFase('FASE1') ? 'Realizar o desempate dos candidatos' : 'Classificação do Examinador' }}
            </button>
          </div>
        </div>
        <div class="action-column">
          <div [matTooltip]="getTooltipVisualizarFase1()"
               matTooltipPosition="above"
               [matTooltipDisabled]="allFase1Concluida && concursoFase === 'FASE2'">
            <button mat-flat-button
                    class="btn-classificacao-fase1"
                    [disabled]="!allFase1Concluida || concursoFase !== 'FASE2'"
                    (click)="visualizarClassificacaoFase1()">
              <mat-icon>visibility</mat-icon>
              Classificação Geral da Fase 1
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="existeEmpateFase('FASE1') && allEnvelopesFinalizados" class="aviso-empate">
        <mat-icon color="warn">warning</mat-icon>
        <span>Existem empates pendentes de resolução</span>
      </div>
    </mat-card-actions>
  </mat-card>

  <mat-card fxFlex="50" class="stage-card">
    <mat-card-header class="stage-header" [ngClass]="{'header-cinza': (!allFase1Concluida || provasFase2[0].aguardandoConsolidacao || allEnvelopesFinalizados), 'stage-progress': allFase1Concluida}">
      <mat-card-title class="stage-title">FASE 2</mat-card-title>
      <div class="status-chip" [ngClass]="{'status-concluida': allFase2Concluida, 'status-bloqueada': !allFase1Concluida}">
        <mat-icon>{{ allFase2Concluida ? 'check_circle' : (allFase1Concluida ? 'hourglass_empty' : 'lock') }}</mat-icon>
        <span>{{ allFase2Concluida ? 'Concluída' : (allFase1Concluida && !provasFase2[0].aguardandoConsolidacao ? 'Em Andamento' : (allFase1Concluida && provasFase2[0].aguardandoConsolidacao ? 'Aguardando Consolidação da Fase 1' : 'Aguardando Fase 1')) }}</span>
      </div>
    </mat-card-header>
    <mat-card-content [class.disabled-content]="!allFase1Concluida">
      <div class="exams-grid">
        <div *ngFor="let prova of provasFase2" class="exam-card" [ngClass]="{'exam-completed': prova.concluido}">
          <div class="exam-info">
            <div class="exam-title-container">
              <span class="exam-title">{{ getNomeProva(prova.tipoProva) }}</span>
              <mat-icon *ngIf="!prova.concluido && prova.emAndamento" class="progress-icon">hourglass_empty</mat-icon>
            </div>
            <span class="exam-meta">Peso: {{ prova.provaPeso }}</span>
            <div *ngIf="isProvaProntaParaLancamento(prova)" class="scores-summary">
              <span>{{ prova.resumoNotas }}</span>
              <div *ngIf="todasNotasAtribuidas(prova) && !prova.comissaoNotaEnvelopeId" class="envelope-alert">
                <mat-icon color="warn">warning</mat-icon>
                <span>Envelope não depositado</span>
              </div>
              <div *ngIf="prova.comissaoNotaEnvelopeId" class="envelope-success">
                <mat-icon>check_circle</mat-icon>
                <span>Envelope depositado</span>
              </div>
            </div>
            <div *ngIf="prova.concluido" class="indicador-concluida">
              <mat-icon>check_circle</mat-icon>
              <span>Prova Concluída</span>
            </div>
          </div>
          <div class="exam-action">
            <button
              *ngIf="isProvaProntaParaLancamento(prova) && !prova.comissaoNotaEnvelopeId"
              mat-flat-button color="primary"
              [routerLink]="['/comissao-julgadora/listar-notas', idConcurso, prova.tipoProva]"
              [queryParams]="{ peso: prova.provaPeso }">
                <mat-icon>edit_note</mat-icon> 
                Atribuir Notas
            </button>

            <button
              *ngIf="isProvaProntaParaLancamento(prova) && prova.comissaoNotaEnvelopeId"
              mat-stroked-button color="primary"
              [routerLink]="['/comissao-julgadora/listar-notas', idConcurso, prova.tipoProva]"
              [queryParams]="{ peso: prova.provaPeso }">
                <mat-icon>visibility</mat-icon> 
                Visualizar Notas
            </button>

            <div *ngIf="!prova.concluido && !isProvaProntaParaLancamento(prova)"
                 class="acao-bloqueada" [matTooltip]="getBloqueioTooltip(prova)">
              <mat-icon>info_outline</mat-icon>
              <span>{{ getBloqueioReason(prova) }}</span>
            </div>

            <button
              *ngIf="isPresidente() && prova.emAndamento && !prova.concluido"
              mat-stroked-button
              (click)="consultarPendenciasProva(prova)"
              matTooltip="Consultar status de avaliação dos examinadores"
            >
              <mat-icon>info</mat-icon>
              Pendências
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions class="btn-actions-center">
      <div class="actions-row">
        <div class="action-column">
          <div [matTooltip]="getTooltipVisualizarClassificacao('FASE2')"
               matTooltipPosition="above"
               [matTooltipDisabled]="!getTooltipVisualizarClassificacao('FASE2')">
            <button mat-flat-button 
                    [color]="existeEmpateFase('FASE2') ? 'warn' : 'primary'"
                    [disabled]="!!getTooltipVisualizarClassificacao('FASE2')"
                    [class.pulse-animation]="existeEmpateFase('FASE2') && !getTooltipVisualizarClassificacao('FASE2')"
                    (click)="realizarDesempateFase('FASE2')">
              <mat-icon>{{ existeEmpateFase('FASE2') ? 'gavel' : 'visibility' }}</mat-icon>
              {{ existeEmpateFase('FASE2') ? 'Realizar o desempate dos candidatos' : 'Classificação do Examinador' }}
            </button>
          </div>
        </div>
        <div class="action-column">
          <div [matTooltip]="getTooltipVisualizarFase2()"
               matTooltipPosition="above"
               [matTooltipDisabled]="classificacaoFase2Consolidada">
            <button mat-flat-button
                    class="btn-classificacao-fase2"
                    [disabled]="!classificacaoFase2Consolidada"
                    (click)="visualizarClassificacaoFase2()">
              <mat-icon>visibility</mat-icon>
              Classificação Geral da Fase 2
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="existeEmpateFase('FASE2') && allEnvelopesFinalizados" class="aviso-empate">
        <mat-icon color="warn">warning</mat-icon>
        <span>Existem empates entre candidatos que precisam ser resolvidos</span>
      </div>
    </mat-card-actions>
  </mat-card>

</div>

<div *ngIf="isPresidente() && !classificacaoFase2Consolidada">
  <div class="alerta-consolidacao-info">
    <mat-icon>info</mat-icon>
    <span>Ao final de cada fase, utilize esta ação para ver pendências dos examinadores e consolidar os resultados.</span>
  </div>
  <mat-card *ngIf="existeProvaAguardandoConsolidacao()" class="alerta-consolidacao-pendente">
    <mat-card-header>
      <mat-icon>warning</mat-icon>
      <mat-card-title>Consolidação Pendente</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      Como presidente, você precisa executar esta ação para visualizar a classificação e consolidar os resultados.
    </mat-card-content>
  </mat-card>
  
  <div class="btn-consolidacao-fase">
    <button *ngIf="podeConsolidarFase() && !temPendencias()" 
            mat-flat-button color="primary"
            [class.pulse-animation]="existeProvaAguardandoConsolidacao() || allFase2Concluida"
            [routerLink]="['/comissao-julgadora/resultado/classificacao', idConcurso]">
      <mat-icon>calculate</mat-icon>
      Seguir para a consolidação da fase
    </button>
    
    <button *ngIf="temPendencias()" 
            mat-flat-button color="warn"
            [disabled]="verificandoPendencias"
            (click)="verificarPendencias()">
      <mat-icon *ngIf="!verificandoPendencias">warning</mat-icon>
      <i *ngIf="verificandoPendencias" class="fa fa-spinner fa-spin"></i>
      {{ verificandoPendencias ? 'Verificando...' : 'Verificar Pendências para Consolidação' }}
    </button>

    <button *ngIf="!podeConsolidarFase() && !temPendencias()" 
            mat-flat-button
            disabled>
      <mat-icon>lock</mat-icon>
      Etapa de consolidação não iniciada
    </button>
  </div>
</div>
